import React from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useStripe, useElements, CardElement } from "@stripe/react-stripe-js";

import "./Styles.css";
import useHttp from "../../../hooks/useHttp";
import { CARD_PAYMENT_URL } from "../../../utils/api-ends";
import LoaderImg from "../../../assets/media/loader.gif";
import { BACKEND_HOST } from "../../../config";
import { STRIPE_PUBLIC_KEY } from "../../../utils/generalData";

const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);
const access_token = JSON.parse(localStorage.getItem("auth_token"))?.access;

const CARD_ELEMENT_OPTIONS = {
  style: {
    base: {
      color: "#32325d",
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: "antialiased",
      fontSize: "16px",
      "::placeholder": {
        color: "#aab7c4",
      },
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  },
};

export default function CardPayment({ amount }) {
  return (
    <>
      <Elements stripe={stripePromise}>
        <CheckoutForm amount={amount} />
      </Elements>
    </>
  );
}

function CheckoutForm({ amount }) {
  const stripe = useStripe();
  const elements = useElements();
  const { paymentRequestId } = useParams();

  const { isLoading, sendRequests: sendStripePaymentMethodRequests } =
    useHttp();
  const navigate = useNavigate();

  const handleSubmit = async (event) => {
    // We don't want to let default form submission happen here,
    // which would refresh the page.
    event.preventDefault();

    if (!stripe || !elements) {
      // Stripe.js has not yet loaded.
      // Make sure to disable form submission until Stripe.js has loaded.
      return;
    }

    const result = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardElement),
      billing_details: {
        // Include any additional collected billing details.
      },
    });

    stripePaymentMethodHandler(result);
  };

  function stripePaymentMethodHandler(result) {
    if (result.error) {
      // Show error in payment form
    } else {
      const response = (data) => {
        handleServerResponse(data);
      };
      sendStripePaymentMethodRequests(
        {
          url: CARD_PAYMENT_URL,
          method: "post",
          data: {
            payment_method_id: result.paymentMethod.id,
            payment_request_id: paymentRequestId,
          },
        },
        response
      );
    }
  }

  function handleServerResponse(response) {
    if (response.error) {
      // Show error from server on payment form
    } else if (response.requires_action) {
      // Use Stripe.js to handle required card action
      stripe
        .handleCardAction(response.payment_intent_client_secret)
        .then(handleStripeJsResult);
    } else {
      // Show success message
      navigate(
        `/payment/${paymentRequestId}/response?response_message=Your card payment of $${amount} has been submitted successfully for processing.`
      );
    }
  }

  function handleStripeJsResult(result) {
    if (result.error) {
      // Show error in payment form
    } else {
      // The card action has been handled
      // The PaymentIntent can be confirmed again on the server
      fetch(BACKEND_HOST + CARD_PAYMENT_URL.url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${access_token}`,
        },
        body: JSON.stringify({
          payment_intent_id: result.paymentIntent.id,
          payment_request_id: paymentRequestId,
        }),
      })
        .then(function (confirmResult) {
          return confirmResult.json();
        })
        .then(handleServerResponse);
    }
  }

  return (
    <form onSubmit={handleSubmit}>
      <CardElement options={CARD_ELEMENT_OPTIONS} />

      <div className="multiple-btn mt-4">
        <button className="m-0" type="submit" disabled={!stripe}>
          Payment
          {isLoading && (
            <img src={LoaderImg} style={{ width: "22px" }} alt="" />
          )}
        </button>
      </div>
    </form>
  );
}
